import { BaseProxy } from "@/proxies/BaseProxy";

export class SectionsProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `sections`,
      parameters,
    });
  }
}
